export default __webpack_public_path__ + "static/media/plus.9dc96d79.svg";